import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AppProvider } from "./hooks/AppContext";
import Navbar from "./components/Navbar";
import MainContent from "./components/MainContent";
import ExtraHeal from "./components/ExtraHeal";
import Footer from "./components/Footer";
import About from "./components/About";
import QA from "./components/Q&A/QA";
import Contact from "./components/Contact";
import ScrollToTopButton from "./components/ScrollToTopButton ";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import UnderConstruction from "./components/UnderConstruction";
import { UNDER_CONSTRUCTION } from "./constants";
import { useSelector } from "react-redux";
import { useRef } from "react";

function MainSite() {
  const mainContentRef = useRef(null);
  const extraHealRef = useRef(null);
  const footerRef = useRef(null);
  const aboutRef = useRef(null);
  const qaRef = useRef(null);
  const contactRef = useRef(null);

  const sectionRefs = {
    extraHeal: extraHealRef,
    mainContent: mainContentRef,
    footer: footerRef,
    about: aboutRef,
    qa: qaRef,
  };

  const isAdminAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated && state.auth.isAdmin
  );

  return (
    <Router>
      <AppProvider>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar sectionRefs={sectionRefs} />
                <div ref={mainContentRef}>
                  <MainContent />
                </div>
                <ExtraHeal
                  ref={extraHealRef}
                  isAdmin={isAdminAuthenticated}
                />
                <About ref={aboutRef} />
                <QA ref={qaRef} />
                <Contact ref={contactRef} />
                <div ref={footerRef}>
                  <Footer />
                </div>
                <ScrollToTopButton />
              </>
            }
          />
          <Route
            path="/admin/login"
            element={
              isAdminAuthenticated ? (
                <Navigate to="/admin/dashboard" replace />
              ) : (
                <AdminLogin />
              )
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              isAdminAuthenticated ? (
                <AdminDashboard />
              ) : (
                <Navigate to="/admin/login" replace />
              )
            }
          />
        </Routes>
      </AppProvider>
    </Router>
  );
}

function App() {
  return UNDER_CONSTRUCTION ? <UnderConstruction /> : <MainSite />;
}

export default App;
